import styled from 'styled-components';

export const RegulationHistoryDescriptionStyle = styled.div`
	> span {
		display: block;
		margin-bottom: ${props => props.theme.spacing.space1}rem;
		text-transform: uppercase;
	}
`;
